import { SVGProps } from 'react';

export const SvgLocation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99998 4.84987C7.00662 4.84987 6.20134 5.69121 6.20134 6.72905C6.20134 7.76689 7.00662 8.60822 7.99998 8.60822C8.99333 8.60822 9.79861 7.76689 9.79861 6.72905C9.79861 5.69121 8.99333 4.84987 7.99998 4.84987ZM5.3005 6.72905C5.3005 5.17141 6.5091 3.9087 7.99998 3.9087C9.49085 3.9087 10.6994 5.17141 10.6994 6.72905C10.6994 8.28669 9.49085 9.5494 7.99998 9.5494C6.5091 9.5494 5.3005 8.28669 5.3005 6.72905Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00234 0.941178C5.50546 0.939415 3.05339 2.4552 2.39847 5.4625C1.62531 9.03127 3.74328 12.1141 5.71008 14.0946C6.99234 15.3808 9.00838 15.3795 10.2822 14.095L10.283 14.0942C12.2569 12.1138 14.3746 9.03837 13.6014 5.46983C12.9499 2.46236 10.4993 0.942941 8.00234 0.941178ZM14.48 5.26203C13.7186 1.74741 10.8384 0.0020041 8.00295 1.72492e-06C5.16741 -0.00200069 2.28526 1.73941 1.52001 5.25402C0.635364 9.33686 3.07288 12.7463 5.0851 14.7724L5.08567 14.773C6.71559 16.4085 9.28369 16.4097 10.9076 14.7724C12.9271 12.7461 15.3646 9.34489 14.48 5.26203Z"
    />
  </svg>
);
